export const MOLDOVA_TZ = "Europe/Chisinau";

// Elevul poate face rezervări online doar într-un interval din zi, după ora
// Chișinăului. Lecțiile și examenul practic au ferestre separate: examenul se
// închide mai devreme, ca personalul să apuce să confirme prezența.
export const PRACTICAL_EXAM_BOOKING_WINDOW = Object.freeze({
   startHour: 9,
   endHour: 17,
});

export const LESSON_BOOKING_WINDOW = Object.freeze({
   startHour: 9,
   endHour: 18,
});

export const STUDENT_BOOKING_WINDOW_TIMEZONE_LABEL = "ora Chișinăului";

export function buildBookingWindowLabel(window) {
   return `Programare disponibilă de la ${window.startHour} până la ${window.endHour}`;
}

export function buildBookingWindowFullLabel(window) {
   return `${buildBookingWindowLabel(window)} (${STUDENT_BOOKING_WINDOW_TIMEZONE_LABEL})`;
}

export function buildBookingWindowBlockedMessage(window) {
   return `Programarea online este activă zilnic între ${window.startHour}:00 și ${window.endHour}:00, după ${STUDENT_BOOKING_WINDOW_TIMEZONE_LABEL}. Revino în acest interval pentru a adăuga rezervări.`;
}

export const PRACTICAL_EXAM_BOOKING_WINDOW_FULL_LABEL =
   buildBookingWindowFullLabel(PRACTICAL_EXAM_BOOKING_WINDOW);

export const PRACTICAL_EXAM_BOOKING_WINDOW_BLOCKED_MESSAGE =
   buildBookingWindowBlockedMessage(PRACTICAL_EXAM_BOOKING_WINDOW);

export const LESSON_BOOKING_WINDOW_FULL_LABEL =
   buildBookingWindowFullLabel(LESSON_BOOKING_WINDOW);

export const LESSON_BOOKING_WINDOW_BLOCKED_MESSAGE =
   buildBookingWindowBlockedMessage(LESSON_BOOKING_WINDOW);

export function getChisinauTimeParts(date = new Date()) {
   const fmt = new Intl.DateTimeFormat("en-GB", {
      timeZone: MOLDOVA_TZ,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
   });
   const parts = fmt.formatToParts(date);
   const read = (type) =>
      Number(parts.find((part) => part.type === type)?.value ?? 0);
   return {
      hour: read("hour"),
      minute: read("minute"),
      second: read("second"),
   };
}

export const STUDENT_BOOKING_SECTOR_OPTIONS = [
   "Botanica",
   "Ciocana",
   "Buiucani",
];

export function normalizeStudentBookingSector(raw) {
   const sector = String(raw ?? "")
      .trim()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();

   if (!sector || sector === "—") return null;
   if (sector.includes("later")) return null;
   if (sector.includes("buiucani") || sector.includes("bui")) return "Buiucani";
   if (sector.includes("ciocana")) return "Ciocana";
   if (sector.includes("botanica")) return "Botanica";
   return null;
}

export function isBookingWindowOpen(window, date = new Date()) {
   const { hour } = getChisinauTimeParts(date);
   return hour >= window.startHour && hour < window.endHour;
}

export function isPracticalExamBookingWindowOpen(date = new Date()) {
   return isBookingWindowOpen(PRACTICAL_EXAM_BOOKING_WINDOW, date);
}

export function isLessonBookingWindowOpen(date = new Date()) {
   return isBookingWindowOpen(LESSON_BOOKING_WINDOW, date);
}
